import { render, staticRenderFns } from "./VirtualAccountPayment.vue?vue&type=template&id=3b52ef52"
import script from "./VirtualAccountPayment.vue?vue&type=script&lang=js"
export * from "./VirtualAccountPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports